import {formatIncompletePhoneNumber} from 'libphonenumber-js';
import {Username} from '~/processes/onboarding-drafts/entities/credentials';

const invalidCharsRE = /[^\d\s]/g;

const stripInvalidChars = (phone: Username.Value) => {
    return phone.replace(invalidCharsRE, '');
};

const ensureStartsWithPlus = (phone: Username.Value) => {
    if (phone[0] === '+') {
        return phone;
    }
    return `+${phone}`;
};

export function formatPhoneNumber(phoneStr: string) {
    phoneStr = stripInvalidChars(phoneStr);
    phoneStr = ensureStartsWithPlus(phoneStr);
    return formatIncompletePhoneNumber(phoneStr);
}

export function clearFormatPhoneNumber(phoneStr: string) {
    if (!phoneStr) return phoneStr;
    let newValue = '';

    if (phoneStr !== '')
        if (phoneStr.charAt(0) === '+') {
            newValue = phoneStr.slice(1);
        }

    return `+${newValue.replace(/\D/g, '')}`;
}
